/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type ColumnAlignment = (typeof ColumnAlignment)[keyof typeof ColumnAlignment];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ColumnAlignment = {
    Left: 'Left',
    Right: 'Right',
} as const;
